import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import './Header.scss';
import Button from './Button';

type Props = {
  fixButtons?: boolean;
};

const HeaderComponent: React.FC<Props> = ({ fixButtons }) => {
  const navigate = useNavigate();
  const { isLoggedIn, userInfo, logout, loading } = useAuth();

  const handleLogout = async () => {
    await logout();
    window.location.href = '/';
  };

  return (
    <header className="basic">
      <div className="header-content">
        <div className="button-container">
          <Link to={`${isLoggedIn ? '/dashboard' : '/'}`}>
            <img src="/logo.png" alt="ViewEventNotes logo" />
            ViewEventNotes
          </Link>
          {isLoggedIn && !fixButtons && (
            <Link to={'/dashboard'}>My Events</Link>
          )}
        </div>
        <div className="button-container">
          {(!isLoggedIn || fixButtons) && (
            <Button
              className="action-button"
              onClick={() => navigate('/Account/Login')}
              isLoading={false}
            >
              Login
            </Button>
          )}
          {(!isLoggedIn || fixButtons) && (
            <Button
              className="action-button"
              onClick={() => navigate('/Account/Register')}
              isLoading={false}
            >
              Register
            </Button>
          )}
          {isLoggedIn && !fixButtons && (
            <Button onClick={handleLogout}>Logout</Button>
          )}
        </div>
      </div>
    </header>
  );
};

export default HeaderComponent;
